import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import EnterpriseToolTabs from 'bundles/internal-enterprise/components/EnterpriseToolTabs';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import BasicProfilesV1 from 'bundles/naptimejs/resources/basicProfiles.v1';

class UserMembershipsRouteHandler extends React.LegacyComponentWithChildren<{
  params: {
    userId: string;
  };
}> {
  static contextTypes = {
    user: PropTypes.instanceOf(BasicProfilesV1).isRequired,
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof UserMembershipsRouteHandler.contextTypes>;

  render() {
    return (
      <div className="rc-UserMembershipRouteHandler">
        <EnterpriseToolTabs userId={this.props.params.userId} />
        {this.props.children}
      </div>
    );
  }
}

export default UserMembershipsRouteHandler;
